<ng-container *ngIf="recordModel.EventType == 3">
  <!-- <i class="fal fa-info-circle"></i> -->
</ng-container>
<ng-container *ngIf="actions.length === 1">
  <button nz-button nz-tooltip [nzTooltipTitle]="actions[0].text | locale" [nzDanger]="actions[0].code === 'delete'"
    nzShape="circle" (click)="actionClicked(actions[0])">
    <i [class]="actions[0].icon"></i>
  </button>
</ng-container>

<ng-container *ngIf="actions.length > 1">
  <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu">
    <i class="far fa-ellipsis-v"></i>
  </a>
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu>
      <ng-container *ngFor="let action of actions">
        <li *ngIf="action.divider" nz-menu-divider></li>
        <ng-container *ngIf="!action.divider">
          <li nz-menu-item [nzDanger]="action.code === 'delete'" (click)="actionClicked(action)">
            <i [class]="action.icon"></i> {{ action.text | locale }}
          </li>
        </ng-container>
      </ng-container>
    </ul>
  </nz-dropdown-menu>
  <!-- <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu>
      <li nz-menu-item nzDanger (click)="deleteConfirm()" *ngIf="section.AdditionalInformationParsed.AllowDelete">
        <i class="fal fa-trash"></i> {{ "Delete" | locale }}
      </li>
      <ng-container *ngIf="allowLineSorting">
        <li nz-menu-divider></li>
        <li nz-menu-item (click)="moveRowUp.emit(data)">
          <i class="fal fa-arrow-to-top"></i> {{ "Move Up" | locale }}
        </li>
        <li nz-menu-item (click)="moveRowDown.emit(data)">
          <i class="fal fa-arrow-to-bottom"></i> {{ "Move Down" | locale }}
        </li>
      </ng-container>
      <ng-container *ngIf="allowSpecialLines">
        <li nz-menu-divider></li>
        <li nz-menu-item (click)="AddTextLine.emit(data)">
          <i class="fal fa-text"></i> {{ "Text Line Below" | locale }}
        </li>
        <li nz-menu-item (click)="AddSubTotal.emit(data)" *ngIf="data.LineType !== 'S'">
          <i class="fal fa-sigma"></i> {{ "Add Subtotal Below" | locale }}
        </li>
      </ng-container>
      <ng-container *ngIf="data.LineType !== 'S' && allowAdd">
        <li nz-menu-divider></li>
        <li nz-menu-item *ngIf="allowAdd" (click)="DuplicateLine.emit(data)">
          <i class=" fal fa-copy"></i> {{'Duplicate Line' | locale}}
        </li>
      </ng-container>
    </ul>
  </nz-dropdown-menu> -->
</ng-container>
